import React from 'react';
import {
  BrowserRouter,
  Route,
  Redirect,
  Switch,
} from 'react-router-dom';

//CONTAINERS
import LoginContainer from './containers/Login/LoginContainer';
import ToolkitContainer from './containers/Toolkit/ToolkitContainer'
import ForgotPasswordContainer from './containers/ForgotPassword/ForgotPasswordContainer';
import ForgotPasswordConfirmContainer from './containers/ForgotPassword/ForgotPasswordConfirmContainer';
import HomePageContainer from './containers/Home/HomePage'
import RegistrationContainer from './containers/Registration/RegistrationContainer';
import ChallengeStatementContainer from './containers/ChallengeStatement/ChallengeStatementContainer';
import BenefitsLadderContainer from './containers/BenefitsLadder/BenefitsLadderContainer';
import InfluencerMapContainer from './containers/InfluencerMap/InfluencerMapContainer';
import CompetitiveAnalysis from './containers/CompetitiveAnalysis/CompetitiveAnalysisContainer';
import SegmentationContainer from './containers/Segmentation/SegmentationContainer';
import SegmentAttractivenessContainer from './containers/SegmentAttractiveness/SegmentAttractivenessContainer';
import AbilityToCompeteContainer from './containers/AbilityToCompete/AbilityToCompeteContainer';
import PrioritizerContainer from './containers/Prioritizer/PrioritizerContainer';
import DifferentialAdvantageContainer from './containers/DifferentialAdvantage/DifferentialAdvantageContainer';
import PositioningStatementContainer from './containers/PositioningStatement/PositioningStatementContainer';
import ValuePropositionContainer from './containers/ValuePropositionContainer/ValuePropositionContainer';
import PricingValueContainer from './containers/PricingValueContainer/PricingValueContainer';

const checkAuth = () => {
  const userToken = localStorage.getItem('userToken');
  const user = localStorage.getItem('user');
  let returnVal = userToken || user;
  return returnVal;
}


const AuthRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    checkAuth() ? (
      <Component {...props} />
    ) : (
        <Redirect to={{ pathname: '/login' }} />
      )
  )} />
)

const Main = (props) => {
  return (
  <main>
   <BrowserRouter>
      <Switch>
        <Route exact path='/' component={HomePageContainer}/>
        <Route path='/login' component={LoginContainer}/>
        <Route path='/registration' component={RegistrationContainer}/>
        <Route exact path='/forgot-password' component={ForgotPasswordContainer}/>
        <Route exact path='/reset-password' component={ForgotPasswordConfirmContainer}/>
        <AuthRoute path='/toolkit' component={ToolkitContainer} />
        <AuthRoute path='/challenge-statement/:id' component={ChallengeStatementContainer}/>
        <AuthRoute path='/influencer-map/:id' component={InfluencerMapContainer}/>
        <AuthRoute path='/benefits-ladder/:id' component={BenefitsLadderContainer}/>
        <AuthRoute path= '/competitive-analysis/:id' component={CompetitiveAnalysis}/>
        <AuthRoute path= '/segmentation/:id' component={SegmentationContainer}/>
        <AuthRoute path= '/segmentAttractiveness/:id' component={SegmentAttractivenessContainer} />
        <AuthRoute path= '/abilityToCompete/:id' component={AbilityToCompeteContainer} />
        <AuthRoute path= '/prioritizer/:id' component={PrioritizerContainer} />
        <AuthRoute path= '/differential-advantage/:id' component={DifferentialAdvantageContainer}/>
        <AuthRoute path='/positioning-statement/:id' component={PositioningStatementContainer}/>
        <AuthRoute path='/value-proposition/:id' component={ValuePropositionContainer}/>
        <AuthRoute path='/pricing-value/:id' component={PricingValueContainer}/>
      </Switch>
    </BrowserRouter>
  </main>
)};

export default Main;



// WEBPACK FOOTER //
// ./src/routes.js